import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { AuraLayout, Layout, Navbar } from "lola-framework-ui-test";
import { useStore } from "../store/globalState";
import { flavorClassName } from "../constants";
import { LegalContent } from "../components/legal/LegalContent";
import { NavbarBackChevron } from "../components/NavbarBackChevron";
import "../styles/legal.style.css";

export const CancellationPage = () => {
  const { theme } = useStore();
  const colorConfig = theme.whiteView;
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <AuraLayout
      colorConfig={colorConfig}
      className={`legal-page ${flavorClassName}`}
    >
      <Layout.Header>
        <NavbarBackChevron onBackClick={() => navigate(-1)}>
          <Navbar
            onBackClick={() => navigate(-1)}
            title={t(`legal.docs.transactionPolicy`)}
            align="center"
          />
        </NavbarBackChevron>
      </Layout.Header>
      <Layout.Content isOverflowauto>
        <div className="legal-modal-content">
          <LegalContent doc="transactionPolicy" />
        </div>
      </Layout.Content>
    </AuraLayout>
  );
};
